import { render, staticRenderFns } from "./ChartLegend.vue?vue&type=template&id=516e079a&"
import script from "./ChartLegend.vue?vue&type=script&lang=js&"
export * from "./ChartLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports